import { action } from 'satcheljs/lib/legacy';
import moveToStore from '../store/store';
/**
 * Sets the shouldShowAllFolders flag
 * @param shouldShow new flag to set
 */
export default action('setShouldShowAllFolders')(function setShouldShowAllFolders(shouldShow) {
    moveToStore.shouldShowAllFolders = shouldShow;
});
//# sourceMappingURL=setShouldShowAllFolders.js.map